import * as Topics from "../Data/Topics";
import * as InputUtils from "../Input/InputUtils";
import { Selectable } from "../Input/Selectable";
import * as MathUtils from "../Utils/MathUtils";
import * as PixiUtils from "../Utils/PixiUtils";
import * as PointUtils from "../Utils/PointUtils";

// TODO:SH: Strip the Chef Leo logic from this class and make it generic and customizable
/**
 * Draggable
 * @todo SH: Strip the Chef Leo logic from this class and make it generic and customizable
 */
export class Draggable extends Selectable {
    // TODO: Can we get rid of these callback arrays?
    public readonly onDragBegin: Array<(p: Draggable) => void>;
    public readonly onDrag: Array<(p: Draggable) => void>;
    public readonly onDragEnd: Array<(p: Draggable) => void>;

    protected _isDrag: boolean;
    protected _pointerOffset: PIXI.Point;

    private _dragThreshholdSq: number;

    constructor() {
        super();
        this._isDrag = false;
        this._pointerOffset = new PIXI.Point(0, 0);
        this._dragThreshholdSq = 15 * 15;

        this.onDragBegin = new Array<(p: Draggable) => void>();
        this.onDrag = new Array<(p: Draggable) => void>();
        this.onDragEnd = new Array<(p: Draggable) => void>();

        this.on(InputUtils.Events.POINTER_MOVE, this.onPointerMove);
    }

    /**
     * Gets whether is dragging
     */
    public get isDragging(): boolean {
        return this._isDrag;
    }

    /**
     * Gets visuals
     */
    public get visuals(): PIXI.Container {
        return this._visuals;
    }

    /**
     * Sets drag threshhold
     * @param pValue
     */
    public set dragThreshhold(pValue: number) {
        this._dragThreshholdSq = pValue * pValue;
    }

    /**
     * Attachs visuals
     */
    public attachVisuals(): void {
        PixiUtils.setParent(this._visuals, this);
    }

    /**
     * Drops draggable
     */
    public drop(): void {
        // override
    }

    /**
     * Selects draggable
     */
    public select(): void {
        super.select();
        PubSub.publishSync(Topics.DRAGGABLE_SELECTED, this);
    }

    /**
     * Deselects draggable
     */
    public deselect(): void {
        super.deselect();
        PubSub.publishSync(Topics.DRAGGABLE_DESELECTED, this);
    }

    /**
     * onPointerDown
     * @param pEvent
     */
    protected onPointerDown(pEvent: PIXI.interaction.InteractionEvent): void {
        super.onPointerDown(pEvent);
        this._isDrag = false;
        this._pointerOffset = PointUtils.subtract(this.position, this._eventData!.getLocalPosition(this.parent));
    }

    /**
     * onPointerUp
     */
    protected onPointerUp(pEvent: PIXI.interaction.InteractionEvent): void {
        if (this._eventData !== undefined && this._eventData.identifier === pEvent.data.identifier) {
            if (this._isDrag) {
                this.dragEnd();
            }
            else {
                super.onPointerUp(pEvent);
            }
        }
    }

    /**
     * onPointerUpOutside
     */
    protected onPointerUpOutside(pEvent: PIXI.interaction.InteractionEvent): void {
        if (this._isDrag) {
            this.onPointerUp(pEvent);
        }
        else {
            super.onPointerUpOutside(pEvent);
        }
    }

    /**
     * onPointerMove
     */
    protected onPointerMove(pEvent: PIXI.interaction.InteractionEvent): void {
        if (this._eventData !== undefined && this._eventData.identifier === pEvent.data.identifier) {
            if (this._isDrag === false) {
                // Calculate how far the mouse has moved
                const delta: number = PointUtils.distanceSq(
                    PointUtils.add(
                        this._eventData.getLocalPosition(this.parent),
                        this._pointerOffset,
                    ),
                    this.position,
                );
                // If it has moved enough, send a message to the DragDropManager and let it handle input
                if (delta >= this._dragThreshholdSq) {
                    this.dragBegin();
                }
            }
            else {
                for (let i = 0; i < this.onDrag.length; ++i) {
                    this.onDrag[i](this);
                }
                this.snapToMouse();
            }
        }
    }

    /**
     * Drag begin
     */
    protected dragBegin(): void {
        for (let i = 0; i < this.onDragBegin.length; ++i) {
            this.onDragBegin[i](this);
        }
        this._isDrag = true;
        PubSub.publishSync(Topics.DRAG_BEGIN, this);
    }

    /**
     * Drag end
     */
    protected dragEnd(): void {
        for (let i = 0; i < this.onDragEnd.length; ++i) {
            this.onDragEnd[i](this);
        }
        this._isDrag = false;
        this._eventData = undefined;
        PubSub.publishSync(Topics.DRAG_END, this);
    }

    /**
     * Snaps to mouse
     */
    protected snapToMouse(): void {
        this._eventData!.getLocalPosition(this._visuals.parent, this._visuals.position as PIXI.Point);
    }
}
